(function () {
  var isMac =
    navigator.platform == "Mac68K" ||
    navigator.platform == "MacPPC" ||
    navigator.platform == "Macintosh" ||
    navigator.platform == "MacIntel";
  if ($(window).width() > 1024) {
    if (!isMac) {
      $(".m_content_head>div>a.win").show();
      $(".m_content_head>div>a.mac").hide();
      if (!$(".m_content_head>div>a.win").length) {
        $(".m_content_head>div>a.mac").show();
      }
      $(".buy_win_m").show();
      $(".buy_mac_m").hide();
      if (!$(".buy_win_m").length) {
        $(".buy_mac_m").show();
      }
    } else {
      $(".m_content_head>div>a.mac").show();
      $(".m_content_head>div>a.win").hide();
      if (!$(".m_content_head>div>a.mac").length) {
        $(".m_content_head>div>a.win").show();
      }
      $(".buy_mac_m").show();
      $(".buy_win_m").hide();
      if (!$(".buy_mac_m").length) {
        $(".buy_win_m").show();
      }
    }
  } else {
    if (!isMac) {
      $(".buy_win_m").show();
      $(".buy_mac_m").hide();
      if (!$(".buy_win_m").length) {
        $(".buy_mac_m").show();
      }
    } else {
      $(".buy_mac_m").show();
      $(".buy_win_m").hide();
      if (!$(".buy_mac_m").length) {
        $(".buy_win_m").show();
      }
    }
  }
})();
// 检测元素
// entry:目标元素,是一个集合，冻结条只有1个所以只取第一个

var observer = new IntersectionObserver(function(entry,observe){
    if(entry[0].boundingClientRect['top'] <= 0){
        $('.m_content_head_box').css({'position':"fixed","top":0,"width":"100%","z-index":"21"})
    }else{
        $('.m_content_head_box').attr({"style":""});
        observer.unobserve($('.m_content_head_box')[0]);
        $('.iphone-eraser-nav').click(function(){
          if($(".iphone-eraser-nav>.center>span>i").attr("class") == "active") {
            $('.m_content_head_box').css({'position':"fixed","top":"0px","width":"100%","z-index":"20"})
           $(".nav_bg").show();
           $(".nav").hide();
          }else{
            $('.m_content_head_box').attr({"style":""});
           $(".nav_bg").hide();
          }
        })
        $('.nav_bg').click(function(){
          $('.m_content_head_box').attr({"style":"position:sticky"});
        })
    }
    //$(".nav").hide();
},{threshold:1})
try{
  observer.observe($('.m_content_head_box')[0]);
  $(".iphone-eraser-nav").click(change_state);
  $(window).resize(function(){
    observer.unobserve($('.m_content_head_box')[0])
    observer.observe($('.m_content_head_box')[0]);
  });
}catch(e){
  console.log(e)
}
function change_state (){
    if ($(window).width() <= 850) {
  $(".iphone-eraser-nav>.center>span>i").toggleClass("active");
    $(".iphone-eraser-nav>.center>ul").toggle();
    $(".nav_bg").toggle();
    }
}
$(".toggle_nav").click(function () {
  if ($(".iphone-eraser-nav>.center>span>i").attr("class") == "active") {
    $(".iphone-eraser-nav>.center>span>i").removeClass("active");
    $(".iphone-eraser-nav>.center>ul").hide();
    $(".nav").toggle();
    return false;
  }else{
    $(".nav").toggle();
  }
  try {
    if ($(".login_box ul").css("display") != "none") {
      $(".login_box ul").hide();
    }
  } catch (e) {
    console.log(e);
  }
  if ($(".nav").css("display") == "none") {
    $(".nav").show();
    $(".nav_bg").show();
    $(".iphone-eraser-nav>.center>ul").hide();
  } else {
    $(".nav").hide();
    $(".nav_bg").hide();
  }
});
$(".login_btn").click(function () {
  $(".iphone-eraser-nav>.center>span>i").removeClass("active");
  $(".iphone-eraser-nav>.center>ul").hide();
});
(function () {
  var toggle = true;
  $("body").append(
    '<img class="gotop" src="https://www.apeaksoft.com/images/top.png" alt="top">'
  );
  $(window).scroll(function () {
    if ($(document).scrollTop() >= 400) {
      $(".gotop").show();
      $(".gotop").click(function () {
        $("body,html").scrollTop(0);
      });
    } else {
      $(".gotop").hide();
    }
    try {
      if (
        $(document).scrollTop() >=
        $(".iphone-eraser-main").offset().top - 200
      ) {
        $(".iphone-eraser-main-right img")
          .eq(6)
          .css("transform", "rotate(0deg)");
        if ($(window).width() >= 500) {
          if (toggle) {
            $(".iphone-eraser-main-right").css({
              transform: "translateY(-20px)",
            });
            setTimeout(function () {
              $(".iphone-eraser-main-right").css({
                transform: "translateY(0px)",
              });
            }, 1000);
            toggle = !toggle;
          }
        }
      }
    } catch (e) {}
  });
  $(window).scroll(function () {
    try {
      if ($(window).width() > 1030) {
        if ($(document).scrollTop() >= $(".g_main").offset().top) {
          $(".g_main_left").addClass("active");
        } else {
          $(".g_main_left").removeClass("active");
        }
      }
    } catch (e) {}
  });
  try {
    var m_content_head_top = $(".m_content_head").offset().top||633;
    $(window).scroll(function () {
      if ($(document).scrollTop() >= m_content_head_top) {
        $(".m_content_head").addClass("m_content_head_active").next();
        if ($(window).width() <= 1024) {
          $(".m_content_head>div>div").show();
        }
      } else {
        $(".m_content_head").removeClass("m_content_head_active");
        $(".m_content_head>div>div").hide();
      }
    });
  } catch (e) {}
  $(window).scroll(function () {
    try {
      if ($(document).scrollTop() >= $(".g_main").eq(0).offset().top + 200) {
        $(".guide_buy.active").show();
      } else {
        $(".guide_buy.active").hide();
      }
    } catch (e) {}
  });
})();

(function () {
  function run(time) {
    if (!window.localStorage.getItem("download_value")) {
      window.localStorage.setItem("download_value", "100000");
    } else if (window.localStorage.getItem("download_value") == "NaN") {
      window.localStorage.setItem("download_value", "100000");
    }
    setTimeout(function () {
      var num = parseInt(window.localStorage.getItem("download_value"));
      var num = String((num += Math.floor(Math.floor(Math.random() * 5 + 1))));
      window.localStorage.setItem("download_value", num);
      $(".download_value_box").html("");
      for (var i = 0; i < num.length; i++) {
        var a = num[i];
        if (i % 3 == 0 && i != 0) {
          $(".download_value_box").append(
            '<i style="border:none;margin:0;padding:0;">,</i>'
          );
        }
        $(".download_value_box").append("<i>" + a + "</i>");
      }
      run(Math.floor(Math.floor(Math.random() * 3 + 1)) + "000");
    }, time);
  }
  run(1);
})();
for (var i = 0; i < $(".features").length; i++) {
  $(".features")
    .eq(i)
    .click(function () {
      $(this).children("a").children("i").toggleClass("active");
      if ($(this).children("a").children("i").attr("class") == "active") {
        $(this).children("a").children("i").css("transform", "rotate(180deg)");
      } else {
        $(this).children("a").children("i").css("transform", "rotate(0deg)");
      }
      $(this).children("div").toggle();
    });
}
(function () {
  var src = $(".box_video div iframe").attr("src");
  $(".play").click(function () {
    $(".box_video").show();
    $(".box_video>div").prepend(
      '<iframe src="' +
        $(this).attr("data-video") +
        '?autoplay=1" frameborder="0" allowfullscreen></iframe>'
    );
  });
  $(".box_video>div>img").click(function () {
    $(".box_video").hide();
    $(".box_video>div iframe").remove();
  });
  $(".box_video").click(function (e) {
    if (e.target.nodeName == "DIV") {
      $(".box_video").hide();
      $(".box_video>div iframe").remove();
    }
  });
})();
(function () {
  if ($(window).width() >= 900) {
    var ind = 0;
    var time = null;
    function run() {
      if (ind >= $(".mobietrans_main div p").length) {
        ind = 0;
      }
      $(".mobietrans_main div img")
        .eq(ind)
        .css("filter", "blur(0)")
        .css("z-index", 3)
        .stop()
        .animate({ left: "30%", width: 480, top: "0%" }, 1000);
      var ind_l = ind + 1;
      if (ind_l >= $(".mobietrans_main div img").length) {
        ind_l = 0;
      }
      $(".mobietrans_main div img")
        .eq(ind_l)
        .css("filter", "blur(.8px)")
        .css("z-index", 2)
        .stop()
        .animate({ left: "0%", width: 338, top: "25%" }, 1000);
      var ind_r = ind - 1;
      if (ind_r < 0) {
        ind_r = $(".mobietrans_main div img").length - 1;
      }
      $(".mobietrans_main div img")
        .eq(ind_r)
        .css("filter", "blur(.8px)")
        .css("z-index", 1)
        .stop()
        .animate({ left: "72%", width: 338, top: "25%" }, 1000);
      $(".mobietrans_main div p")
        .eq(ind)
        .css("display", "block")
        .siblings()
        .css("display", "none");
      $(".mobietrans_main div i")
        .eq(ind)
        .css("background", "#ff612e")
        .siblings()
        .css("background", "#ffcbc0");
      $(".mobietrans_main div i")
        .eq(ind)
        .stop()
        .animate({ width: 45 + "px" }, 200)
        .siblings()
        .stop()
        .animate({ width: 9 + "px" }, 500);
    }
    clearInterval(time);
    function tab() {
      time = setInterval(function () {
        ind++;
        run();
      }, 4000);
    }
    $(".mobietrans_main div i").click(function () {
      clearInterval(time);
      ind = $(this).index();
      run();
      tab();
    });
    tab();
    return false;
  } else {
    $(".mobietrans_main div img").eq(0).addClass("active");
    $(".mobietrans_main div i").click(function () {
      var ind = $(this).index();
      $(".mobietrans_main div img")
        .eq(ind)
        .addClass("active")
        .siblings()
        .removeClass("active");
      $(".mobietrans_main div p")
        .eq(ind)
        .css("display", "block")
        .siblings()
        .css("display", "none");
      $(".mobietrans_main div i")
        .eq(ind)
        .css("background", "#ff612e")
        .siblings()
        .css("background", "#ffcbc0");
      $(".mobietrans_main div i")
        .eq(ind)
        .stop()
        .animate({ width: 45 + "px" }, 200)
        .siblings()
        .stop()
        .animate({ width: 9 + "px" }, 500);
    });
  }
})();
(function () {
  var maxHeight=0
  for(var i=0;i<$('.new_comment_box div>div p').length;i++){
    if(maxHeight<$('.new_comment_box div>div p').eq(i).height()){
      maxHeight=$('.new_comment_box div>div p').eq(i).height()
    }
  }
  $('.new_comment_box div>div p').height(maxHeight)
  $('.new_comment_box div:nth-child(2) span').click(function () {
   $('.new_comment_box div>div>i').eq($(this).index()).click();
  });
  $(".new_comment_box div>div>i").click(function () {
    $(this)
      .css("background", "#ff612e")
      .siblings()
      .css("background", "#ffcbc0");
    $(".new_comment_box div>div p")
      .eq($(this).index())
      .addClass("active")
      .siblings()
      .removeClass("active");
    $(".new_comment_box div>div img")
      .eq($(this).index())
      .addClass("active")
      .siblings()
      .removeClass("active");
    $(".author_name")
      .eq($(this).index())
      .addClass("active")
      .siblings()
      .removeClass("active");
    if ($(this).index() == 0) {
      $(".new_comment_box div>div img,.author_name").eq(0).css({ order: 2 });
      $(".new_comment_box div>div img,.author_name").eq(1).css({ order: 1 });
      $(".new_comment_box div>div img,.author_name").eq(2).css({ order: 3 });
    } else if ($(this).index() == 1) {
      $(".new_comment_box div>div img,.author_name").eq(0).css({ order: 1 });
      $(".new_comment_box div>div img,.author_name").eq(1).css({ order: 2 });
      $(".new_comment_box div>div img,.author_name").eq(2).css({ order: 3 });
    } else {
      $(".new_comment_box div>div img,.author_name").eq(0).css({ order: 1 });
      $(".new_comment_box div>div img,.author_name").eq(1).css({ order: 3 });
      $(".new_comment_box div>div img,.author_name").eq(2).css({ order: 2 });
    }
    $(this)
      .animate({ width: 45 + "px", display: "inline-block" }, 200)
      .siblings()
      .animate({ width: 9 + "px", display: "inline-block" }, 200);
  });
  var i = 0;
  setInterval(function () {
    i++;
    if (i >= $(".new_comment_box div>div>i").length) {
      i = 0;
    }
    $(".new_comment_box div>div>i")
      .eq(i)
      .css("background", "#ff612e")
      .siblings()
      .css("background", "#ffcbc0");
    $(".new_comment_box div>div p")
      .eq(i)
      .addClass("active")
      .siblings()
      .removeClass("active");
    $(".new_comment_box div>div img")
      .eq(i)
      .addClass("active")
      .siblings()
      .removeClass("active");
    $(".author_name").eq(i).addClass("active").siblings().removeClass("active");
    if (i == 0) {
      $(".new_comment_box div>div img,.author_name").eq(0).css({ order: 2 });
      $(".new_comment_box div>div img,.author_name").eq(1).css({ order: 1 });
      $(".new_comment_box div>div img,.author_name").eq(2).css({ order: 3 });
    } else if (i == 1) {
      $(".new_comment_box div>div img,.author_name").eq(0).css({ order: 1 });
      $(".new_comment_box div>div img,.author_name").eq(1).css({ order: 2 });
      $(".new_comment_box div>div img,.author_name").eq(2).css({ order: 3 });
    } else {
      $(".new_comment_box div>div img,.author_name").eq(0).css({ order: 1 });
      $(".new_comment_box div>div img,.author_name").eq(1).css({ order: 3 });
      $(".new_comment_box div>div img,.author_name").eq(2).css({ order: 2 });
    }
    $(".new_comment_box div>div>i")
      .eq(i)
      .animate({ width: 45 + "px", display: "inline-block" }, 200)
      .siblings()
      .animate({ width: 9 + "px", display: "inline-block" }, 200);
  }, 4000);
})();
$(".Features_main div").mouseover(function () {
  $(this).addClass("active").siblings().removeClass("active");
});
c_tabs($(".use_iphone_transfer>ul"), $(".use_iphone_transfer>div"), "active");
$(".use_iphone_transfer_box")
  .eq(0)
  .find("ul")
  .find("li")
  .rotation_chart(
    $(".use_iphone_transfer_box>div div").eq(0),
    $(".use_iphone_transfer_box>div").eq(0).find("img").eq(0),
    $(".use_iphone_transfer_box>div").eq(0).find("img").eq(1),
    "active",
    7000
  );
$(".use_iphone_transfer_box")
  .eq(1)
  .find("ul")
  .find("li")
  .rotation_chart(
    $(".use_iphone_transfer_box>div div").eq(1),
    $(".use_iphone_transfer_box>div").eq(1).find("img").eq(0),
    $(".use_iphone_transfer_box>div").eq(1).find("img").eq(1),
    "active",
    7000
  );
$(".use_iphone_transfer_box")
  .eq(2)
  .find("ul")
  .find("li")
  .rotation_chart(
    $(".use_iphone_transfer_box>div div").eq(2),
    $(".use_iphone_transfer_box>div").eq(2).find("img").eq(0),
    $(".use_iphone_transfer_box>div").eq(2).find("img").eq(1),
    "active",
    7000
  );
$(".use_iphone_transfer_box")
  .eq(3)
  .find("ul")
  .find("li")
  .rotation_chart(
    $(".use_iphone_transfer_box>div div").eq(3),
    $(".use_iphone_transfer_box>div").eq(3).find("img").eq(0),
    $(".use_iphone_transfer_box>div").eq(2).find("img").eq(1),
    "active",
    7000
  );
$(".use_iphone_transfer_box")
  .eq(4)
  .find("ul")
  .find("li")
  .rotation_chart(
    $(".use_iphone_transfer_box>div div").eq(4),
    $(".use_iphone_transfer_box>div").eq(4).find("img").eq(0),
    $(".use_iphone_transfer_box>div").eq(2).find("img").eq(1),
    "active",
    7000
  );
$(".product_guide_box")
  .find("ul")
  .find("li")
  .rotation_chart(
    $(".product_guide_box>div div"),
    $(".product_guide_box>div").find("img").eq(0),
    $(".product_guide_box>div").find("img").eq(1),
    "active",
    7000
  );
  (function($){$.fn.extend({device_confirm:function(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;}})})(jQuery);(function($){$.fn.extend({system_confirm:function(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}}})})(jQuery);if(window.innerWidth>956){$(".tab_index").mouseenter(function(){$("#submenu_container").addClass("active"); $(".submenu").eq($(this).index(".tab_index")).addClass("active").siblings(".submenu").removeClass("active");});$("#submenu_container").mouseleave(function(){$("#submenu_container").removeClass("active");$(".submenu").removeClass("active");});};function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
//系统识别
if(system_confirm()=="mac"){var isMac=true}
else if(system_confirm()=="win"){var isMac=false}
if(device_confirm()==true){var device_id=true}
else if(device_confirm()==false){var device_id=false}else{};
if (isMac) {
  $('.mac_btn_box').css({"display":"flex"});
  $('.mac_btn').css({"display":"block"});
  $('.mac_nav_btn').css({"display":"block"});
  $('.win_btn_box').css({"display":"none"});
  $('.win_btn').css({"display":"none"});
  $('.windows_nav_btn').css({"display":"none"});
//   guide
  $('.guide_mac').css({"display":"flex"});
  $('.guide_windows').css({"display":"none"});
  $('.subnav_mac').addClass('active');
  $('.subnav_win').removeClass('active');
  $('.g_main_mac').addClass('active');
  $('.g_main_win').removeClass('active');
} else if (!isMac) {
  $('.win_btn_box').css({"display":"flex"});
  $('.win_btn').css({"display":"block"});
  $('.mac_btn_box').css({"display":"none"});
  $('.mac_nav_btn').css({"display":"none"});
  $('.mac_btn').css({"display":"none"});
  $('.windows_nav_btn').css({"display":"block"});
//   guide
  $('.guide_windows').css({"display":"flex"});
  $('.guide_mac').css({"display":"none"});
  $('.subnav_win').addClass('active');
  $('.subnav_mac').removeClass('active');
  $('.g_main_win').addClass('active');
  $('.g_main_mac').removeClass('active');
} else if (device_id == false) {
  $('.pc_btn').css({"display":"none"});
  $('.mobile_btn').css({"display":"block"});
};
// windows和mac切换
(function(){
  !isMac ? $('.switch_change').addClass('is_windows') : $('.switch_change').addClass('is_mac');
  if(!isMac){
      $('.guide_windows').css({"display":"flex"});
      $('.guide_mac').css({"display":"none"});
      $('.inline_windows').css({"display":"inline-block"});
      $('.inline_mac').css({"display":"none"});
      $('.windows_btn').css({"display":"flex"});
      $('.mac_btn').css({"display":"none"});
      $('.windows_nav_btn').css({"display":"block"});
      $('.mac_nav_btn').css({"display":"none"});
      $(this).removeClass('is_mac').addClass('is_windows');
  }else{
      $('.guide_mac').css({"display":"flex"});
      $('.guide_windows').css({"display":"none"});
      $('.inline_windows').css({"display":"none"});
      $('.inline_mac').css({"display":"inline-block"});
      $('.windows_btn').css({"display":"none"});
      $('.mac_btn').css({"display":"flex"});
      $('.windows_nav_btn').css({"display":"none"});
      $('.mac_nav_btn').css({"display":"block"});
      $('.switch_change i').toggleClass('active');
      $(this).removeClass('is_windows').addClass('is_mac');
  }
  $('.switch_change i').click(function(){
      if($(this).attr('class').indexOf('win')<0){
          // 如果是windows,->切换显示mac
          $('.guide_mac').css({"display":"flex"});
          $('.guide_windows').css({"display":"none"});
          $('.inline_windows').css({"display":"none"});
          $('.inline_mac').css({"display":"inline-block"});
          $('.windows_btn').css({"display":"none"});
          $('.mac_btn').css({"display":"flex"});
          $('.windows_nav_btn').css({"display":"none"});
          $('.mac_nav_btn').css({"display":"block"});

          $('.switch_change i.mac').addClass('active');
          $('.switch_change i.win').removeClass('active');
      }else{
          $('.guide_windows').css({"display":"flex"});
          $('.guide_mac').css({"display":"none"});
          $('.inline_windows').css({"display":"inline-block"});
          $('.inline_mac').css({"display":"none"});
          $('.windows_btn').css({"display":"flex"});
          $('.mac_btn').css({"display":"none"});
          $('.windows_nav_btn').css({"display":"block"});
          $('.mac_nav_btn').css({"display":"none"});

          $('.switch_change i.mac').removeClass('active');
          $('.switch_change i.win').addClass('active');
      }
  })
})();